import { Tooltip, useDisclosure } from "@chakra-ui/react";
import type { UserProfile } from "@src/__generated__/graphql";
import type { User } from "@src/__generated__/urql-graphql";
import { Avatar } from "@src/components/ui-kit/Avatar";
import { observer } from "mobx-react-lite";
import type { DeepPick } from "ts-essentials";

interface TeamMembersProps {
  members: {
    id: User["id"];
    full_name: User["full_name"];
    profile?: Pick<UserProfile, "hex_color"> | null;
    image?: DeepPick<
      User["image"],
      {
        urls: {
          thumbnail: never;
        };
      }
    >;
  }[];
}

const TeamMembers = ({ members }: TeamMembersProps) => {
  // Workaround to enable tooltip work on mobile
  const { isOpen, onOpen, onClose } = useDisclosure();
  if (!members.length) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center mt-1">
      {members.map((member) => (
        <Tooltip
          key={member.id}
          isOpen={isOpen}
          label={
            <div className="text-lg text-center">
              <p>{member.full_name}</p>
            </div>
          }
        >
          <div className="pr-4 pt-2">
            <Avatar
              colorScheme={member.profile?.hex_color}
              name={member.full_name}
              src={member.image?.urls.thumbnail || undefined}
              onMouseEnter={onOpen}
              onMouseLeave={onClose}
            />
          </div>
        </Tooltip>
      ))}
    </div>
  );
};

export default observer(TeamMembers);
